var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.$constants.LOADING_COLOR },
      }),
      _vm._v(" "),
      _vm.drug && _vm.drug.id
        ? _c(
            "form",
            {
              attrs: { action: "" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.saveDrug.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Название на платформе"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.drug.title,
                              expression: "drug.title",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { required: "", type: "text" },
                          domProps: { value: _vm.drug.title },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(_vm.drug, "title", $event.target.value)
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Название на английском"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.drug.en_title,
                              expression: "drug.en_title",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: { value: _vm.drug.en_title },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.drug,
                                "en_title",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [_vm._v("Морион")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.drug.id,
                              expression: "drug.id",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { disabled: "", type: "text" },
                          domProps: { value: _vm.drug.id },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(_vm.drug, "id", $event.target.value)
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Действующее вещество"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.drug.substance,
                              expression: "drug.substance",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: { value: _vm.drug.substance },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.drug,
                                "substance",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Данные для страны (поставщиков)"),
                            ]),
                            _vm._v(" "),
                            _c("TitleForSuppliers", {
                              ref: "suppliersTitles",
                              attrs: { records: _vm.allDetails },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("SelectCombineDrugs", {
                          ref: "combineDrugs",
                          staticClass: "mt-1",
                          attrs: {
                            selectedCombinedList: _vm.drug.combined_drugs,
                            selectedCombineType: _vm.drug.combined_type,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _c(
                          "div",
                          { staticClass: "flex flex_gap_5 align-items-center" },
                          [
                            _c("label", [_vm._v("Габариты препарата")]),
                            _vm._v(" "),
                            !_vm.editDrugDimensions
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-default btn-xs",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        _vm.editDrugDimensions = true
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                редактировать\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-popover",
                              {
                                attrs: {
                                  placement: "bottom",
                                  "auto-hide": true,
                                },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-info btn-xs",
                                    attrs: { type: "button" },
                                  },
                                  [_vm._v("Отправить на замер")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "template",
                                  { slot: "popover" },
                                  [
                                    _c("div", { staticClass: "mt-1" }, [
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", [
                                          _vm._v("Страна препарата"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.newDimension.countryId,
                                                expression:
                                                  "newDimension.countryId",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.$set(
                                                  _vm.newDimension,
                                                  "countryId",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              { attrs: { value: "0" } },
                                              [_vm._v("Страна по факту замера")]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.$AllCountries,
                                              function (c) {
                                                return _c(
                                                  "option",
                                                  { domProps: { value: c.id } },
                                                  [_vm._v(_vm._s(c.name))]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("LoadingButton", {
                                      attrs: {
                                        title: "Отправить",
                                        loading: _vm.btnLoading,
                                        type: "button",
                                        color: _vm.$constants.LOADING_COLOR,
                                        onClick: () =>
                                          _vm.getDimensionTask(_vm.drug.id),
                                        className:
                                          "btn btn-outline-info btn-xs mt-1",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("CountryDimension", {
                          ref: "countryDimensions",
                          attrs: {
                            disableToEdit: !_vm.editDrugDimensions,
                            drugId: _vm.drug.id,
                            records: _vm.allDetails,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm.access.projectPrices
                ? _c("div", { staticClass: "card" }, [
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _c("TasksProjectCreate", {
                          attrs: {
                            drugId: _vm.drug.id,
                            prices: _vm.drug.prices,
                            tasks: _vm.drug.tasks,
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-9" },
                      [_c("Recipe", { attrs: { detail: _vm.details.recipe } })],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3 pt-4" }, [
                      _c("label", { attrs: { for: "ch11" } }, [
                        _vm._v("Регулярный прием (кол. дней)"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group mb-3" }, [
                        _c("div", { staticClass: "input-group-prepend" }, [
                          _c("div", { staticClass: "input-group-text" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.details.regular_reception.use.value,
                                  expression:
                                    "details.regular_reception.use.value",
                                },
                              ],
                              attrs: { id: "ch11", type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.details.regular_reception.use.value
                                )
                                  ? _vm._i(
                                      _vm.details.regular_reception.use.value,
                                      null
                                    ) > -1
                                  : _vm.details.regular_reception.use.value,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a =
                                      _vm.details.regular_reception.use.value,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.details.regular_reception.use,
                                          "value",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.details.regular_reception.use,
                                          "value",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.details.regular_reception.use,
                                      "value",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.details.regular_reception.days.value,
                              expression:
                                "details.regular_reception.days.value",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "number" },
                          domProps: {
                            value: _vm.details.regular_reception.days.value,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.details.regular_reception.days,
                                "value",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Фасовка"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.drug.packaging,
                              expression: "drug.packaging",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "number" },
                          domProps: { value: _vm.drug.packaging },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.drug,
                                "packaging",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card shadow-sm" }, [
                _c(
                  "div",
                  { staticClass: "card-body" },
                  [
                    _c("EgkSelect", {
                      ref: "egkCodes",
                      attrs: {
                        details: Object.values(_vm.details.egk),
                        updateDetail: (d) => (this.details.egk = d),
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card shadow-sm" }, [
                _c("div", { staticClass: "card-header" }, [
                  _c("h5", [
                    _vm._v("Справочные / спрос\n          "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.showUploadToCatalog = !_vm.showUploadToCatalog
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.showUploadToCatalog ? "скрыть" : "показать"
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm.showUploadToCatalog
                  ? _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _c("p", [
                          _vm._v(
                            "Выгружать на справочные с учетом свободных остатков на складе доп. препаратов"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("PairDrugWithKoeff", {
                          ref: "pairDrugWithKoeff",
                          attrs: {
                            savedRecords:
                              _vm.details?.related_drug?.upload_to_catalog ??
                              [],
                            drugId: _vm.drug.id,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _vm.access.countryCurrency
                        ? [
                            _c("div", { staticClass: "col-md-3" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Страна / Валюта"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.drug.income_country_id,
                                        expression: "drug.income_country_id",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    on: {
                                      change: [
                                        function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.drug,
                                            "income_country_id",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                        _vm.updateCostPrice,
                                      ],
                                    },
                                  },
                                  _vm._l(_vm.$AllCountries, function (country) {
                                    return _c(
                                      "option",
                                      { domProps: { value: country.id } },
                                      [
                                        _vm._v(
                                          _vm._s(country.name) +
                                            " /\n                    " +
                                            _vm._s(
                                              _vm.$AllCurrencies[
                                                country.currency_id
                                              ].currency
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "mt-1" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.newCountry,
                                          expression: "newCountry",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.newCountry = $event.target
                                              .multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                          _vm.addNewCountry,
                                        ],
                                      },
                                    },
                                    [
                                      _c("option", { attrs: { value: "0" } }, [
                                        _vm._v(
                                          "Выберите дополнительную страну"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.$AllCountries,
                                        function (country) {
                                          return _c(
                                            "option",
                                            { domProps: { value: country.id } },
                                            [_vm._v(_vm._s(country.name))]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    _vm._l(
                                      _vm.details.extra.country,
                                      function (country) {
                                        return !country || !country.to_delete
                                          ? _c(
                                              "div",
                                              { staticClass: "input-group" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: country.name,
                                                      expression:
                                                        "country.name",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: { disabled: "" },
                                                  domProps: {
                                                    value: country.name,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        country,
                                                        "name",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "input-group-append",
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-outline-danger",
                                                        attrs: {
                                                          type: "button",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.removeCountry(
                                                              country
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "icon-fa icon-fa-trash",
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e()
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-9" }, [
                        _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _c("div", { staticClass: "col-md-4" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Страна производства"),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.details.manufacturer.country.value,
                                      expression:
                                        "details.manufacturer.country.value",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text" },
                                  domProps: {
                                    value:
                                      _vm.details.manufacturer.country.value,
                                  },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.details.manufacturer.country,
                                        "value",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm.access.costPrice
                              ? [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c("div", { staticClass: "form-group" }, [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v("Себестоимость"),
                                      ]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.drug.cost_price,
                                            expression: "drug.cost_price",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: { disabled: "", type: "text" },
                                        domProps: {
                                          value: _vm.drug.cost_price,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.drug,
                                              "cost_price",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]),
                                  ]),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.access.projectedPrice
                              ? [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c("div", { staticClass: "form-group" }, [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v("Индикативная цена"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-group" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.drug.projected_price,
                                                expression:
                                                  "drug.projected_price",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              step: "any",
                                              type: "number",
                                            },
                                            domProps: {
                                              value: _vm.drug.projected_price,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.drug,
                                                  "projected_price",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "input-group-append",
                                            },
                                            [
                                              _c("input", {
                                                staticClass: "form-control",
                                                attrs: {
                                                  type: "text",
                                                  disabled: "",
                                                },
                                                domProps: {
                                                  value:
                                                    Math.round(
                                                      (+_vm.drug
                                                        .projected_price ?? 0) *
                                                        (_vm.$AllCurrencies[
                                                          _vm.drug
                                                            .income_currency_id
                                                        ]?.rate ?? 1) *
                                                        100
                                                    ) / 100,
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-4" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _vm._v("Код PZN\n                    "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-default btn-xs",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addPZNCode(null)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Добавить PZN\n                    "
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.details.grouped.manufacturer,
                                  function (man, i) {
                                    return [
                                      !man.barcode &&
                                      (!man.pzn || !man.pzn.to_delete)
                                        ? _c(
                                            "div",
                                            { staticClass: "pzn_code flex" },
                                            [
                                              _c("div", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: man.pzn.value,
                                                      expression:
                                                        "man.pzn.value",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    placeholder: "PZN",
                                                    type: "text",
                                                  },
                                                  domProps: {
                                                    value: man.pzn.value,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        man.pzn,
                                                        "value",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                man.comment
                                                  ? _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            man.comment.value,
                                                          expression:
                                                            "man.comment.value",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        placeholder:
                                                          "Комментарий",
                                                        type: "text",
                                                      },
                                                      domProps: {
                                                        value:
                                                          man.comment.value,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            man.comment,
                                                            "value",
                                                            $event.target.value
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-outline-danger",
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.addPZNCode(i)
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "icon-fa icon-fa-trash",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  }
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "mt-1" },
                              [
                                _c("APZNDetail", {
                                  attrs: { records: _vm.allDetails },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Производитель"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.details.manufacturer.title.value,
                              expression: "details.manufacturer.title.value",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: {
                            value: _vm.details.manufacturer.title.value,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.details.manufacturer.title,
                                "value",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Комплектность"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.drug.pack_set,
                              expression: "drug.pack_set",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "number" },
                          domProps: { value: _vm.drug.pack_set },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.drug,
                                "pack_set",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt-1" },
                          [
                            !_vm.requestData.openOrders
                              ? [
                                  _c("LoadingButton", {
                                    attrs: {
                                      title: "загрузить открытые заявки",
                                      className:
                                        "btn btn-xs btn-outline-success",
                                      type: "button",
                                      onClick: _vm.getOpenOrders,
                                      loading: _vm.requestLoading,
                                      color: _vm.$constants.SUCCESS_COLOR,
                                    },
                                  }),
                                ]
                              : [
                                  _vm.requestData.openOrders.orders &&
                                  _vm.requestData.openOrders.orders.length
                                    ? [
                                        _vm._l(
                                          _vm.requestData.openOrders.orders,
                                          function (order) {
                                            return _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "mr-1 badge badge-info",
                                              },
                                              [_vm._v(_vm._s(order.id))]
                                            )
                                          }
                                        ),
                                        _vm._v(" "),
                                        _c("div", [
                                          _c(
                                            "a",
                                            {
                                              attrs: { href: "#" },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  _vm.mixinGoToRouter(
                                                    "searchOrder",
                                                    {
                                                      ordersId:
                                                        _vm.requestData.openOrders.orders.map(
                                                          (o) => o.id
                                                        ),
                                                    }
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        показать заявки в поиске\n                      "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    : [
                                        _c(
                                          "p",
                                          { staticClass: "badge badge-dark" },
                                          [_vm._v("Открытых заявок не найдено")]
                                        ),
                                      ],
                                ],
                          ],
                          2
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(0),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mb-3" },
                    [
                      _c("Registration", {
                        attrs: {
                          drug: _vm.drug,
                          detail: _vm.details.registration,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.details.suppliers_link_data
                ? _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-8" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "div",
                                { staticClass: "flex flex_gap_10 mb-1" },
                                [
                                  _vm._v("Линки для UTEKA\n                "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-default btn-xs",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addPZNCode(null, "uteka")
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Добавить\n                  линк\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "alert alert-info p-1 m-0" },
                                    [
                                      _vm._v(
                                        "\n                  0.5 - ютеки 100р отобр. как 50р; 2 - ютеки 100 р как 200р\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.details.suppliers_link_data.uteka,
                                function (r, i) {
                                  return [
                                    !r.to_delete
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "flex no_border_round",
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: r.value,
                                                  expression: "r.value",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                placeholder: "uteka link",
                                                type: "text",
                                              },
                                              domProps: { value: r.value },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    r,
                                                    "value",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: r.decimal_value,
                                                  expression: "r.decimal_value",
                                                },
                                              ],
                                              staticClass:
                                                "form-control small_input",
                                              attrs: {
                                                placeholder: "Коэфф, 1, 0.5",
                                                type: "text",
                                              },
                                              domProps: {
                                                value: r.decimal_value,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    r,
                                                    "decimal_value",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: r.extra_data.comment,
                                                  expression:
                                                    "r.extra_data.comment",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                placeholder: "Комментарий",
                                                type: "text",
                                              },
                                              domProps: {
                                                value: r.extra_data.comment,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    r.extra_data,
                                                    "comment",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-outline-danger",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addPZNCode(
                                                      i,
                                                      "uteka"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "icon-fa icon-fa-trash",
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                }
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("BAR коды\n                "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-default btn-xs",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addPZNCode(null, "barcode")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "Добавить BAR\n                  код\n                "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.details.manufacturer.barcode,
                                function (man, i) {
                                  return [
                                    !man || !man.to_delete
                                      ? _c(
                                          "div",
                                          { staticClass: "pzn_code flex" },
                                          [
                                            _c("div", [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: man.value,
                                                    expression: "man.value",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  placeholder: "BAR код",
                                                  type: "text",
                                                },
                                                domProps: { value: man.value },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      man,
                                                      "value",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-outline-danger",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addPZNCode(
                                                      i,
                                                      "barcode"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "icon-fa icon-fa-trash",
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                }
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Линк для EAPTEKA"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.details.suppliers_link_data.eapteka
                                      .value,
                                  expression:
                                    "details.suppliers_link_data.eapteka.value",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text" },
                              domProps: {
                                value:
                                  _vm.details.suppliers_link_data.eapteka.value,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.details.suppliers_link_data.eapteka,
                                    "value",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Линк для APTEKAMOS"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.details.suppliers_link_data.aptekamos
                                      .value,
                                  expression:
                                    "details.suppliers_link_data.aptekamos.value",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text" },
                              domProps: {
                                value:
                                  _vm.details.suppliers_link_data.aptekamos
                                    .value,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.details.suppliers_link_data.aptekamos,
                                    "value",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-4" },
                          [
                            _vm.access.supplier ? [_vm._m(1)] : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Коэфициент закупки у поставщиков"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.details.suppliers_data.order_rate
                                        .value,
                                    expression:
                                      "details.suppliers_data.order_rate.value",
                                  },
                                ],
                                class: {
                                  "form-control": true,
                                  bg_success_back:
                                    _vm.details.suppliers_data.order_rate
                                      .value &&
                                    _vm.details.suppliers_data.order_rate
                                      .value !== 0,
                                },
                                attrs: {
                                  placeholder: "Коэфициент 2,5,10....",
                                  type: "number",
                                },
                                domProps: {
                                  value:
                                    _vm.details.suppliers_data.order_rate.value,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.details.suppliers_data.order_rate,
                                      "value",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Фасовка закупки блистеров"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.details.suppliers_data
                                        .oposit_order_rate.value,
                                    expression:
                                      "details.suppliers_data.oposit_order_rate.value",
                                  },
                                ],
                                class: {
                                  "form-control": true,
                                  bg_success_back:
                                    _vm.details.suppliers_data.oposit_order_rate
                                      .value &&
                                    _vm.details.suppliers_data.oposit_order_rate
                                      .value !== 0,
                                },
                                attrs: {
                                  placeholder: "Коэфициент 2,5,10....",
                                  type: "number",
                                },
                                domProps: {
                                  value:
                                    _vm.details.suppliers_data.oposit_order_rate
                                      .value,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.details.suppliers_data
                                        .oposit_order_rate,
                                      "value",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ],
                          2
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  { staticClass: "card-body" },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-6" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Ключевые слова ( разделитель - запятая )"),
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.drug.keywords,
                                expression: "drug.keywords",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { rows: "3" },
                            domProps: { value: _vm.drug.keywords },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.drug,
                                  "keywords",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-6" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Главный ключевик (разделитель - запятая)"),
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.drug.main_keywords,
                                expression: "drug.main_keywords",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { rows: "3" },
                            domProps: { value: _vm.drug.main_keywords },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.drug,
                                  "main_keywords",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-4" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              "Комментарии по упаковке (для всех сотрудников)"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.drug.pack_box_comment,
                                expression: "drug.pack_box_comment",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { rows: "3" },
                            domProps: { value: _vm.drug.pack_box_comment },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.drug,
                                  "pack_box_comment",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              "Информация для проектов, работающих со справочными и ЕГК"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.details.comment.egkProjects.value,
                                expression: "details.comment.egkProjects.value",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { rows: "3" },
                            domProps: {
                              value: _vm.details.comment.egkProjects.value,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.details.comment.egkProjects,
                                  "value",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              "Комментарий по закупке (для администрации)"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.drug.purchase_comment,
                                expression: "drug.purchase_comment",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { rows: "3" },
                            domProps: { value: _vm.drug.purchase_comment },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.drug,
                                  "purchase_comment",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-2" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              "Комментарий по выкладке на складах (для кладовщиков)"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("DrugCommentsBlock", {
                            ref: "drugsStoresComments",
                            attrs: { detail: _vm.details.stores_info.comments },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v(
                            "Информация (временная) для менеджеров (сроки годности, скидка, возможность замены и\n            т.п.)"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("DrugCommentsBlock", {
                          ref: "drugsManagersComments",
                          attrs: { detail: _vm.details.managers_info.comments },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.access.priority
                      ? [_c("Priority", { attrs: { drug: _vm.drug } })]
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-right" },
                      [
                        _c("LoadingButton", {
                          attrs: {
                            title: _vm.drug.id
                              ? "Сохранить"
                              : "Создать препарат",
                            className: "btn btn-success",
                            type: "submit",
                            onClick: () => {},
                            loading: _vm.btnLoading,
                            color: "white",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-3" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("label", { attrs: { for: "" } }, [_vm._v("Тип")]),
        _vm._v(" "),
        _c("select", { staticClass: "form-control", attrs: { disabled: "" } }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "" } }, [_vm._v("Поставщик")]),
      _vm._v(" "),
      _c("select", { staticClass: "form-control", attrs: { disabled: "" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }